import { ENetworkRole, NetworkStreamType } from '~/src/dash/api/network';
import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';

export const ChipNetworkRoleOwner = createChipWihFadingBackgroundVariations(
  '#F0072C',
  'rgba(255, 5, 5, 0.10)',
  'rgba(255, 5, 5, 0.05)',
  'rgba(255, 5, 5, 0.15)',
);

export const ChipNetworkRoleRead = createChipWihFadingBackgroundVariations(
  '#5865E8',
  'rgba(88,101,232,0.10)',
  'rgba(88,101,232,0.05)',
  'rgba(88,101,232,0.15)',
);

export const ChipNetworkStreamVOD = createChipWihFadingBackgroundVariations(
  '#00C488',
  'rgba(0,196,136,0.10)',
  'rgba(0,196,136,0.01)',
  'rgba(0,196,136,0.15)',
);

export const ChipNetworkStreamFOD = createChipWihFadingBackgroundVariations(
  '#00C488',
  'rgba(0,196,136,0.10)',
  'rgba(0,196,136,0.01)',
  'rgba(0,196,136,0.15)',
);

export const ChipNetworkStreamLive = createChipWihFadingBackgroundVariations(
  '#707070',
  'rgba(112,112,112,0.10)',
  'rgba(112,112,112,0.05)',
  'rgba(112,112,112,0.15)',
);

export function networkRoleToChip(status: ENetworkRole): any {
  if (status === undefined) {
    return undefined;
  }

  switch (status) {
    case ENetworkRole.ROLE_UNKNOWN:
      return ChipNetworkStreamLive;
    case ENetworkRole.ROLE_OWNER:
      return ChipNetworkRoleOwner;
    case ENetworkRole.ROLE_READ:
      return ChipNetworkRoleRead;
    default:
      return undefined;
  }
}

export function networkStreamTypeToChip(stream: NetworkStreamType): any {
  if (stream === undefined) {
    return undefined;
  }

  switch (stream) {
    case NetworkStreamType.TYPE_VOD:
      return ChipNetworkStreamVOD;
    case NetworkStreamType.TYPE_LIVE:
      return ChipNetworkStreamLive;
    case NetworkStreamType.TYPE_FOD:
      return ChipNetworkStreamFOD;
    default:
      return undefined;
  }
}
